import { useMutationCreateScheduledVersion } from '@ben/columbia/hooks/use-mutation-create-scheduled-version';
import { useInvalidateScheduledVersion } from '@ben/columbia/hooks/use-query-scheduled-version';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import RenewalWindowModal from '../renewal-window-modal';

interface AddNewVersionModalProps {
  opened: boolean;
  onClose: () => void;
  benefitId?: string;
}

const AddNewVersionModal = ({
  opened,
  onClose,
  benefitId,
}: AddNewVersionModalProps) => {
  const navigate = useNavigate();
  const invalidateScheduledVersion = useInvalidateScheduledVersion();

  const { mutate: createScheduledVersion, isLoading } =
    useMutationCreateScheduledVersion({
      onSuccess: (data) => {
        void invalidateScheduledVersion(benefitId);
        navigate(`/benefits/${benefitId}/version/${data.enrollableBenefitId}/`);
        toast.success('Scheduled version created');
        onClose();
      },
      onError: () => {
        toast.error('Error creating scheduled version');
      },
    });

  return (
    <RenewalWindowModal
      title="Add new version"
      description={
        'Please note that creating a new version of the benefit will override the current version on the effective renewal date.\n\nOnce the renewal window begins, it will not be possible to edit or delete the new benefit version'
      }
      buttonLabel="Add new version"
      opened={opened}
      onClose={onClose}
      onSubmit={(renewalConfig) =>
        createScheduledVersion({ benefitId, renewalConfig })
      }
      isSubmitting={isLoading}
    />
  );
};

export default AddNewVersionModal;
